<template>
    <div
        class="w-100 cursor-pointer transition-all px-10 py-2 bg-try rounded-pill primary--border d-flex flex-row justify-center align-center primary--text position-relative"
        @click="playOrPauseTrack"
    >
        <span class="font-size-18">{{ $t('bookReading.listen_read_aloud') }}</span>
        <v-icon class="primary--text mx-3">mdi-volume-high</v-icon>
    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
    props: {
        currentVoice: { type: String, default: 'Mia' }
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
        }),
    },
    data() {
        return {
            audio: null,
        }
    },
    methods: {
        playOrPauseTrack() {
            if (this.audio && !this.audio.paused) {
                this.audio.pause()
            }
            const audio = new Audio(`${process.env.VUE_APP_VOICE_SAMPLE_URL}${this.currentVoice}.mp3`);
            audio.play()
                .then(() => {
                    this.audio = audio;
                })
                .catch(() => {
                    this.audio = null;
                });
        },
    },
}
</script>

<style scoped>
.primary--border {
    border: 1.5px solid #514773 !important;
}
.bg-try {
    background: white !important;
}
.bg-try:hover {
    background: rgb(216, 216, 216) !important;
}

.line-progress {
    background: #756b9546 !important;
    left: 0;
    height: 100%;
    transition: all 1s linear;
}
</style>
